export default function () {
  const pictures = document.querySelectorAll('.page-template-page-shop2021-product .product li.with-picture img');

  const selectPictureEvent = (ev) => {
    ev.currentTarget.closest('ul').querySelectorAll('li.selected').forEach((e) => e.classList.remove('selected'));
    let li = ev.currentTarget.closest('li');
    li.classList.add('selected');
    let options = {
      behavior: window.JS_SCROLL_BEHAVIOR,
      block: 'nearest',
      inline: 'start'
    };
    li.scrollIntoView(options);
    document.querySelector('.page-template-page-shop2021-product .product .photo img').setAttribute('src', ev.target.getAttribute('src'));
  };

  pictures.forEach((el) => el.addEventListener('click', selectPictureEvent));
  if (pictures.length > 0) {
    pictures[0].click();
  } else {
    document
      .querySelectorAll(
        '.page-template-page-shop2021-product .photo .arrow-right, .page-template-page-shop2021-product .photo .arrow-left'
      ).forEach((el => el.classList.add('hidden')));
  }

  const showNextImage = (ev) => {
    let list = ev.currentTarget.closest('.photos').querySelector('ul');
    let selected = list.querySelector('li.selected');
    if (selected.nextElementSibling && selected.nextElementSibling.classList.contains('with-picture')) {
      selected.nextElementSibling.querySelector('img').click();
    } else {
      list.querySelector('li:first-child img').click();
    }
  };

  const showPrevImage = (ev) => {
    let list = ev.currentTarget.closest('.photos').querySelector('ul');
    let selected = list.querySelector('li.selected');
    if (selected.previousElementSibling && selected.previousElementSibling.classList.contains('with-picture')) {
      selected.previousElementSibling.querySelector('img').click();
    } else {
      let pics = [...list.querySelectorAll('li.with-picture img')];
      let lastPic = pics.at(-1);
      if (lastPic) {
        lastPic.click();
      }
    }
  };

  const scrollProductToLeftSide = (ev, factor = 1) => {
    target = (ev.target) ? ev.target : ev;
    let recommendedProducts = target.closest('.recommended-products');
    let direction = target.closest('[class*="arrow-"]').classList.contains('arrow-left') ? -1 : 1;
    factor = factor * direction;
    let scrollContainer = recommendedProducts.querySelector('ul.products');
    let left = recommendedProducts.querySelector('li').clientWidth * factor;

    scrollContainer.scrollTo({ left, behavior: window.JS_SCROLL_BEHAVIOR });

    let isAtBeginning = left <= 1;
    let isAtEnd = left >= (scrollContainer.scrollWidth - scrollContainer.clientWidth);

    recommendedProducts.querySelectorAll('[class*="arrow-"]').forEach(el => el.classList.remove('hidden'));
    if (isAtBeginning) {
      recommendedProducts.querySelector('.arrow-left').classList.add('hidden');
    } else if (isAtEnd) {
      recommendedProducts.querySelector('.arrow-right').classList.add('hidden');
    }
  };

  document.querySelectorAll('.page-template-page-shop2021-product .photo .arrow-right').forEach((el) => {
    el.addEventListener('click', showNextImage);
  });
  document.querySelectorAll('.page-template-page-shop2021-product .photo .arrow-left').forEach((el) => {
    el.addEventListener('click', showPrevImage);
  });

  if (document.querySelectorAll('.recommended-products ul.items.products li').length > 4) {
    document.querySelector('.recommended-products .arrow-left, .recommended-products').classList.add('with-arrows');
    // initializes arrow (left and right)
    scrollProductToLeftSide(document.querySelector('.recommended-products .arrow-left'), 0);
    document.querySelectorAll('.recommended-products .arrow-left, .recommended-products .arrow-right').forEach(el => {
      el.addEventListener('click', scrollProductToLeftSide);
    });
  }

  document.querySelectorAll('.tech-specs .specs').forEach((el) => {
    if (el.clientHeight >= (el.scrollHeight - 30)) {
      el.classList.add('no-toggle-more');
    }
  });

};
